import GuidanceRegistry from '../guidance-registry.js';
import store from '../../store';

GuidanceRegistry.register({
    type: "action-item-ewf-configure-cobra-rates",
    prompt: (guidanceItem) => getPrompt(guidanceItem),
    beforeLoad: async (component, guidanceItem) => {
        await component.refreshPermissions();
    },
    openAction: { 
        text: "Where to set up Cobra plans and rates?",
        url: (guidanceItem) => `employer-cobra`,
        row: null
    },
    completeAction: {
        visible: () => true
    }
});

async function getCobraRateDates(guidanceItem) {
    return await romeApi.get(`employer/${guidanceItem.employerId}/workflow/${guidanceItem.workflowId}/cobra-rate-date`);
}

async function getPrompt(guidanceItem){

    let date = await getCobraRateDates(guidanceItem);

    if( store.state.employer.usesOurCobra == true) {
        return `To set up plans and rates for all ${date} COBRA benefits (including HRA, FSA, Telescope or Intellect, if offered), or to add new plans to your existing plans, click the Create button and complete the steps. If an existing plan appears with “None” under Current Rates, click on that plan to add new rates.`;
    }

    return `To set up plans and rates for all ${date} COBRA benefits (including HRA, FSA, Telescope or Intellect, if offered), or to add new plans to your existing plans, click the Create Plan button and complete the steps. If an existing plan appears with a red “Needed” indicator, click on that plan to add new rates.`
}



// WEBPACK FOOTER //
// ./src/guidance/items/guidance-cobra-rates.js